import type { MouseEvent } from "react"
import { isExternalUrl } from "@/utilities/url/url-utilities"

export type OpenInNewTab = "determineFromSource" | boolean

export type LinkVariant =
  | "inherit"
  | "inverse"
  | "primary"
  | "secondary"
  | "accent"
  | null

export function getLinkTarget(
  href: string,
  openInNewTab: OpenInNewTab,
): "_blank" | undefined {
  if (openInNewTab === "determineFromSource") {
    return isExternalUrl(href) ? "_blank" : undefined
  }

  return openInNewTab ? "_blank" : undefined
}

export function isModifiedClick(event: MouseEvent): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
}
